module.exports = __webpack_public_path__ + "static/media/won_icon_150.887170d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/won_icon_150.png
// module id = 608
// module chunks = 0